import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Input } from "antd";
import CouponTitle from "./couponTitle";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Appliedcoupon = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <section className="applied-coupon">
      <Link to="" onClick={showModal} className="apply-coupen ">
        <Button type="primary">Apply</Button>
      </Link>

      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        title={null}
        header={null}
        footer={null}
        centered={true}
      >
        <Row>
          <Col>
            <CouponTitle title="Coupon Applied" />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="cashback">
              <p>
                You got ₹1 OFF. Cashback Credits worth ₹0 will be added to your
                Zoom Wallet post booking completion
              </p>
            </div>
          </Col>
        </Row>
      </Modal>
    </section>
  );
};

export default Appliedcoupon;
